module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no data":"No data","coding_violations":"Coding violations","noise_margin":"Noise margin","severe_error_seconds":"Severe error seconds","spontaneous_resyncs":"Spontaneous resyncs"},"de":{"no data":"Keine Daten","coding_violations":"Coding violations","noise_margin":"Noise margin","severe_error_seconds":"Severe error seconds","spontaneous_resyncs":"Spontaneous resyncs"}}')
  delete Component.options._Ctor
}
